import i18n from '@/plugins/i18n';

// USER_TITLES is function maded to translate text after changing lang.
// To use it in components type USER_TITLES()

export const MAIN_USER_TITLES = () => [
  {
    text: i18n.t('forms.titleOptions.mister'),
    value: 'Mr',
  },
  {
    text: i18n.t('forms.titleOptions.missis'),
    value: 'Mrs',
  },
];

export const USER_TITLES = () => [
  ...MAIN_USER_TITLES(),
  {
    text: i18n.t('forms.titleOptions.miss'),
    value: 'Ms',
  },
  {
    text: i18n.t('forms.titleOptions.other'),
    value: 'Other',
  },
  {
    text: i18n.t('forms.titleOptions.unidentified'),
    value: 'Unidentified',
  },
];

export const PROVIDER_TITLES = () => [
  {
    text: i18n.t('forms.titleOptions.doctor'),
    value: 'Dr',
  },
];
